import React, { useCallback } from "react";
import logo from "../../assets/images/csd-rvg-registration-logo.svg";
import { useMsal } from "@azure/msal-react";
import { AccountInfo } from "@azure/msal-browser";
import css from "./PageHeader.module.scss";
import {
  Avatar,
  Divider,
  ListItemIcon,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { blue } from "@material-ui/core/colors";
import PersonIcon from "@material-ui/icons/Person";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useTranslation } from "react-i18next";
import { getCurrentAccount } from "../../services/authService";

export interface IProps {
  account: AccountInfo | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    avatar: {
      backgroundColor: blue[500],
    },
  })
);

export const Header: React.FC = () => {
  const classes = useStyles();
  const [userInitial, setUserInitial] = React.useState<string>("");
  const [userName, setUserName] = React.useState<string>("");

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openBoolean = Boolean(anchorEl);
  const { instance } = useMsal();
  const { t } = useTranslation();


  const logout = useCallback(() => {
    instance.logout();
  }, [instance]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  React.useEffect(() => {
    const idTokenClaims: any = getCurrentAccount()?.idTokenClaims;
    const { family_name, given_name } = idTokenClaims;

    setUserInitial(`${given_name[0]}${family_name[0]}`);
    setUserName(`${given_name} ${family_name}`);
  }, []);

  return (
    <>
      <div className={css.pageHeader}>
        <div className={css.logo}>
          <img src={logo} alt="Carestream Dental logo" />
          <h1>
            <strong>CSD </strong>
            Device registration
          </h1>
        </div>
        <div className={css.account}>
          <div onClick={handleMenu}>
            <Avatar className={classes.avatar}>{userInitial}</Avatar>
          </div>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={openBoolean}
            onClose={handleClose}
          >
            <MenuItem disabled={true}>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              {userName}
            </MenuItem>
            <Divider />
            <MenuItem onClick={logout}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              {t("Logout")}
            </MenuItem>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default Header;
